firebird.factory('videoTouchBarService', [
    '$rootScope',
    '$window',
    'logService',
    'attendeeService',
    'helperService',
    'configService',
    'videoGlobalService',
    function ($rootScope, $window, logService, attendeeService, helperService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        const logger = new LogServiceWrapper(logService, 'videoTouchBarService');
        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // OSX touchbar.
            self.touchBar = false;

            self.initTouchBar = initTouchBar;
            self.updateTouchBar = updateTouchBar;
        }

        function initTouchBar() {
            return new Promise((resolve, reject) => {
                try {
                    self.touchBar = configService.getClientValue('touchBar') === 'true';
                    if (!self.touchBar) {
                        resolve();
                        return;
                    }

                    if (helperService.isElectron() && helperService.isMac()) {
                        $window.preloadedApi.remote.ipcRenderer.onVideoroomButtonClick(function (ev, data) {
                            logger.log('onVideoroomButtonClick', 'button clicked', data);
                            handleButtonsClick(data);
                        });

                        const touchBarButtons = [
                            'button:microphone',
                            ' ',
                            'button:camera',
                            ' ',
                            'button:screen',
                            ' ',
                            'button:chat',
                            '*',
                            //'label:status', // TODO: not updated for now.
                            'button:labs'
                        ];

                        Promise.resolve($window.preloadedApi.remote.ipcRenderer.sendInitTouchbar(touchBarButtons))
                            .then(self.updateTouchBar())
                            .then(resolve())
                            .catch(err => {
                                logger.error('initTouchBar', 'sendInitTouchbar failed', err);
                                reject(err);
                            });
                    } else {
                        logger.log('initTouchBar', 'Cannot initialize touch bar, not on electron or Mac.');
                        resolve();
                    }
                } catch (err) {
                    self.touchBar = false;
                    logger.error('initTouchBar', 'Failed to initialize touch bar', err);
                    resolve();
                }
            });
        }

        function handleButtonsClick(buttonName) {
            let key = buttonName.toLowerCase();
            try {
                // TODO: use better way to toggle instead of DOM click.
                switch (key) {
                    case 'camera': {
                        let cameraBtn = $window.$('#toggle-cam .icon-tooltip-container');
                        cameraBtn.click();
                        break;
                    }
                    case 'microphone': {
                        let micBtn = $window.$('#toggle-mic .icon-tooltip-container');
                        micBtn.click();
                        break;
                    }
                    case 'screen': {
                        //TODO: this causes it to show screen/app selection box. instead select first full screen source by default.
                        //$window.$('#share-desktop .icon-tooltip-container').click();
                        if (!self.screenshareState && !self.screenshare) {
                            selectFirstSourceToScreenshare();
                        } else {
                            let chreenShareBtn = $window.$('#share-desktop .icon-tooltip-container');
                            chreenShareBtn.click();
                        }
                        break;
                    }
                    case 'chat': {
                        $window.$('aside#sidebar-left:not(.toggled) #sidebar-toggle-button').click();
                        $window.$('aside#sidebar-left #chat-tab')[0].click();
                        $window.$('aside#sidebar-left #chat .chat-text-container > textarea').focus();
                        break;
                    }
                    case 'labs': {
                        self.toggleStatsDisplay();
                        $rootScope.$broadcast('showhide-feature-flags');
                        break;
                    }
                    default: {
                        logger.error('handleButtonsClick', 'Button key is not handled ', { buttonName });
                    }
                }
            } catch (ex) {
                logger.error('handleButtonsClick', 'Failed to handle buttom click ', { buttonName }, ex);
            }
        }

        function selectFirstSourceToScreenshare() {
            const options = { types: ['screen'] };
            return $window.preloadedApi.desktopCapturer
                .getSources(options)
                .then(function (sources) {
                    var firstScreen = sources[0];
                    if (firstScreen) {
                        $rootScope.$broadcast('electron-screen-selected', {
                            name: firstScreen.name,
                            id: firstScreen.id,
                            displayId: firstScreen.display_id
                        });
                    }
                })
                .catch(err => {
                    logger.error('selectFirstSourceToScreenshare', 'Failed to select first source to screenshare', err);
                });
        }

        function updateTouchBar(key) {
            return new Promise((resolve, reject) => {
                if (!self.touchBar) {
                    resolve();
                    return;
                }

                if (!helperService.isElectron() || !helperService.isMac()) {
                    resolve();
                    return;
                }

                var data = {};
                if (!key || key === 'microphone') {
                    data.microphone = attendeeService.getIsAudioMuted()
                        ? 'Unmute &#x1F3A4;|#ff0000'
                        : 'Mute &#x1F3A4;|#6ab04c';
                }
                if (!key || key === 'camera') {
                    data.camera = attendeeService.getIsVideoMuted()
                        ? 'Start &#x1f4f9;|#666666'
                        : 'Stop &#x1f4f9;|#6ab04c';
                }
                if (!key || key === 'screen') {
                    data.screen =
                        !self.screenshareState && !self.screenshare
                            ? 'Share &#x1F5A5;|#666666'
                            : 'Stop &#x1F5A5;|#6ab04c';
                }
                if (!key || key === 'chat') {
                    data.chat = 'Show &#x1f4ac;|#666666';
                }
                // if (!key || key == 'status') {
                //     var value;
                //     data.status = (value !== undefined ? value : 'Status') + '|#ffffff';
                // }
                if (!key || key === 'labs') {
                    data.labs = 'Labs|#444444';
                }
                var convertHTMLEntity = function (text) {
                    var span = document.createElement('span');

                    return text.replace(/&[#A-Za-z0-9]+;/gi, function (entity, position, text) {
                        span.innerHTML = entity;
                        return span.innerText;
                    });
                };
                for (var attr in data) {
                    data[attr] = convertHTMLEntity(data[attr]);
                }

                logger.log('updateTouchBar', 'Update TouchBar', data);
                Promise.resolve($window.preloadedApi.remote.ipcRenderer.sendUpdateTouchbar(data))
                    .then(resolve())
                    .catch(err => {
                        logger.error('updateTouchBar', 'Failed to update touchbar', err);
                        reject(err);
                    });
            });
        }
    }
]);
